var _defs, _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG15({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.945,
    height: 80.948,
    viewBox: "0 0 80.945 80.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.948,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.948,
    fill: "#57bf2b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.927,9.736V12.6h.024l1.925-2H7.9V23.1h2.744V6.774H8.454Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.168,11.951a2.477,2.477,0,0,0-2.311,1.131h-.024V9.014h4.718V6.776H12.33v9.2h2.5v-.363c0-.962.433-1.492,1.2-1.492.843,0,1.181.578,1.181,1.469v3.948C17.217,20.4,16.9,21,16.061,21c-.938,0-1.274-.626-1.274-1.589V17.367H12.281v1.855c0,2.478.988,4.067,3.78,4.067,2.768,0,3.9-1.469,3.9-3.731v-4c0-2.575-1.323-3.61-2.792-3.61",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.178,0H2.563a.18.18,0,0,1,.18.18V6.073a.18.18,0,0,1-.18.18H.179A.179.179,0,0,1,0,6.074V.178A.178.178,0,0,1,.178,0Z",
    transform: "translate(30.955 54.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.714,63.513H20.407a.185.185,0,0,0-.18.185v2.4a.179.179,0,0,0,.18.177H59.714a.18.18,0,0,0,.18-.177V63.7a.186.186,0,0,0-.18-.185",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.714,68.289H20.407a.179.179,0,0,0-.18.177v2.41a.181.181,0,0,0,.18.177H59.714a.181.181,0,0,0,.18-.177v-2.41a.18.18,0,0,0-.18-.177",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.234,48.205a5.817,5.817,0,0,0-3.4-1.281,4.543,4.543,0,0,0-3.157,1.341.339.339,0,0,0-.1.247v.214a.342.342,0,0,0,.112.269.315.315,0,0,0,.277.064.336.336,0,0,0,.074-.019.507.507,0,0,0,.2-.124,3.185,3.185,0,0,1,1.575-.328,5.945,5.945,0,0,1,4.05,1.7l.036.032a.473.473,0,0,0,.342.142.462.462,0,0,0,.333-.139l.032-.033a5.965,5.965,0,0,1,4.055-1.7,3.182,3.182,0,0,1,1.579.328.575.575,0,0,0,.217.133.482.482,0,0,0,.23.007.337.337,0,0,0,.248-.324v-.189a.336.336,0,0,0-.106-.243,4.55,4.55,0,0,0-3.195-1.378,5.771,5.771,0,0,0-3.393,1.283",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.795,32.539a.327.327,0,0,0-.171.207l-.04.131a.335.335,0,0,0,.051.3.327.327,0,0,0,.244.133.138.138,0,0,0,.049,0,.422.422,0,0,0,.19-.049,1.006,1.006,0,0,1,.238-.026,3.409,3.409,0,0,1,2.808,1.834l.014.025a.4.4,0,0,0,.251.2.5.5,0,0,0,.125.019.411.411,0,0,0,.2-.049l.026-.012a3.914,3.914,0,0,1,1.754-.434,2.666,2.666,0,0,1,1.792.574.449.449,0,0,0,.132.146,1.006,1.006,0,0,0,.128.062.477.477,0,0,0,.058.008.2.2,0,0,0,.035,0,.337.337,0,0,0,.156-.039.331.331,0,0,0,.167-.2l.033-.116a.3.3,0,0,0,.013-.1A.321.321,0,0,0,58,34.988a2.956,2.956,0,0,0-2.667-1.6,4.192,4.192,0,0,0-1.414.265,3.437,3.437,0,0,0-2.651-1.485,3.273,3.273,0,0,0-1.474.373",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.489,38.587l.011.177a.332.332,0,0,0,.157.265.339.339,0,0,0,.265.04l.057-.018a.428.428,0,0,0,.17-.126,2.888,2.888,0,0,1,1.5-.34,4.855,4.855,0,0,1,3.108,1.176l.028.028a.463.463,0,0,0,.3.114h.029a.461.461,0,0,0,.308-.148l.027-.03A4.719,4.719,0,0,1,50.9,38.132a2.346,2.346,0,0,1,1.024.187.519.519,0,0,0,.2.107.463.463,0,0,0,.144.009.49.49,0,0,0,.082-.02.333.333,0,0,0,.223-.338l-.009-.153a.33.33,0,0,0-.118-.234,3.854,3.854,0,0,0-2.514-.99,4.682,4.682,0,0,0-2.942,1.217,4.917,4.917,0,0,0-2.623-.87,3.75,3.75,0,0,0-2.789,1.288.35.35,0,0,0-.091.252",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,41.742a4.261,4.261,0,0,1,4.261-4.261c.093,0,.183.008.273.013a5.763,5.763,0,1,1,10.927,2.95,6.441,6.441,0,0,1-1.4,12.73c-.26,0-8.6-.05-8.6-.05a4.557,4.557,0,0,1-3.319-7.686,4.257,4.257,0,0,1-2.146-3.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.877,6.779h1.112v5.707h1.327v.907H25.877Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(28.921 6.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.775,6.779h2.6v.907H31.887V9.579H33v.9H31.887v2.917H30.775Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.956,6.779H36.61v.907H35.068V9.579h1.1v.9h-1.1v2.01H36.61v.907H33.956Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.123,21.581V18.03c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682m-2.254-.176V18.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.787,18.956v4.156H29.85V16.5h1.093l1.2,3.794V16.5h.927v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.471,16.5h1.112v5.707H37.91v.907H35.471Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.608,21.015H40.5l-.439-2.654h-.01Zm-1.4,2.1L39.462,16.5H40.73l1.259,6.614H40.847l-.205-1.21h-1.18l-.2,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.375,18.956v4.156h-.937V16.5h1.093l1.2,3.794V16.5h.927v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.951,22.2c.458,0,.634-.273.634-.673V18.069a.579.579,0,0,0-.634-.663h-.469v4.8ZM49.7,18.274v3.063c0,1.015-.419,1.775-1.61,1.775H46.37V16.5h1.717c1.191,0,1.61.752,1.61,1.776",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG15);
export default __webpack_public_path__ + "static/media/G15.33ab609e77d9d546eb650c4b4167a296.svg";
export { ForwardRef as ReactComponent };